// Company Executive Manager
// Handles dynamic addition and removal of executive fields

class CompanyExecutiveManager {
  constructor() {
    this.executiveIndex = 0;
    this.init();
  }

  init() {
    // Initialize existing executives
    this.updateExecutiveNumbers();
    
    // Add event listeners
    this.addEventListeners();
  }

  addEventListeners() {
    // Add executive button
    const addBtn = document.querySelector('.add-executive-btn');
    if (addBtn) {
      addBtn.addEventListener('click', () => this.addExecutiveRow());
    }

    // Remove executive buttons (delegated event)
    const container = document.querySelector('#executives-container');
    if (container) {
      container.addEventListener('click', (e) => {
        if (e.target.classList.contains('remove-executive-btn')) {
          this.removeExecutiveRow(e.target);
        }
      });
    }
  }

  addExecutiveRow() {
    const container = document.querySelector('#executives-container');
    if (!container) return;

    // Get the next available index
    const existingRows = container.querySelectorAll('.executive-row');
    this.executiveIndex = existingRows.length;

    // Create new executive row
    const newRow = this.getExecutiveTemplate();
    container.insertAdjacentHTML('beforeend', newRow);
    
    // Update executive numbers
    this.updateExecutiveNumbers();
  }

  removeExecutiveRow(button) {
    const row = button.closest('.executive-row');
    if (!row) return;

    // Remove the row completely
    row.remove();
    
    // Update executive numbers
    this.updateExecutiveNumbers();
  }

  getExecutiveTemplate() {
    return `
      <div class="executive-row">
        <div class="executive-header">
          <h5>Ejecutivo</h5>
          <button type="button" class="remove-executive-btn btn btn-sm btn-outline-danger" title="Eliminar ejecutivo">✕</button>
        </div>
        
        <div class="executive-fields-row">
          <div class="executive-field">
            <label>Cargo</label>
            <select name="company[executives][${this.executiveIndex}][cargo]" class="form-control">
              <option value="">Seleccionar cargo...</option>
              <option value="EJECUTIVO PRINCIPAL">Ejecutivo Principal</option>
              <option value="EJECUTIVO COBRANZA">Ejecutivo Cobranza</option>
              <option value="SUSCRIPTOR">Suscriptor</option>
              <option value="JEFE SINIESTROS">Jefe Siniestros</option>
            </select>
          </div>
          
          <div class="executive-field">
            <label>Área</label>
            <select name="company[executives][${this.executiveIndex}][area]" class="form-control">
              <option value="">Seleccionar área...</option>
              <option value="Gerencia">Gerencia</option>
              <option value="Cobranza">Cobranza</option>
              <option value="Comercial">Comercial</option>
              <option value="Siniestros">Siniestros</option>
              <option value="Técnica">Técnica</option>
            </select>
          </div>
        </div>
        
        <div class="executive-fields-row">
          <div class="executive-field">
            <label>Nombre</label>
            <input type="text" name="company[executives][${this.executiveIndex}][nombre]" class="form-control" placeholder="Nombre del ejecutivo">
          </div>
          
          <div class="executive-field">
            <label>Apellido</label>
            <input type="text" name="company[executives][${this.executiveIndex}][apellido]" class="form-control" placeholder="Apellido del ejecutivo">
          </div>
        </div>
        
        <div class="executive-fields-row">
          <div class="executive-field">
            <label>Email</label>
            <input type="email" name="company[executives][${this.executiveIndex}][mail]" class="form-control" placeholder="ejecutivo@empresa.cl">
          </div>
          
          <div class="executive-field">
            <label>Teléfono</label>
            <input type="text" name="company[executives][${this.executiveIndex}][telefono]" class="form-control" placeholder="Ej: +56 2 2345 6789">
          </div>
          
          <div class="executive-field">
            <label>Celular</label>
            <input type="text" name="company[executives][${this.executiveIndex}][celular]" class="form-control" placeholder="Ej: +56 9 8765 4321">
          </div>
        </div>
      </div>
    `;
  }

  updateExecutiveNumbers() {
    const rows = document.querySelectorAll('.executive-row');
    rows.forEach((row, index) => {
      const header = row.querySelector('.executive-header h5');
      if (header) {
        header.textContent = `Ejecutivo ${index + 1}`;
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CompanyExecutiveManager();
});
